/** Keep the store's utility dropdown centered on its link when space permits,
 * shifting only enough to keep every column within the viewport. Delegation
 * also covers sections replaced by the theme editor without duplicate owners.
 */
import { isElementVisible } from '@theme/utilities';

function positionDropdown(item) {
  const dropdown = item?.querySelector('.utility-bar__dropdown');
  if (!(dropdown instanceof HTMLElement) || !isElementVisible(dropdown)) return;
  dropdown.style.setProperty('--utility-dropdown-offset', '0px');
  const rect = dropdown.getBoundingClientRect();
  const gutter = 16;
  const offset = rect.left < gutter
    ? gutter - rect.left
    : Math.min(0, document.documentElement.clientWidth - gutter - rect.right);
  dropdown.style.setProperty('--utility-dropdown-offset', `${offset}px`);
}

function positionOpenDropdowns() {
  document.querySelectorAll('.utility-bar__item--has-children').forEach(positionDropdown);
}

document.addEventListener('pointerover', (event) => {
  if (!(event.target instanceof Element)) return;
  const item = event.target.closest('.utility-bar__item--has-children');
  if (!item || (event.relatedTarget instanceof Node && item.contains(event.relatedTarget))) return;
  positionDropdown(item);
});

document.addEventListener('focusin', (event) => {
  if (event.target instanceof Element) positionDropdown(event.target.closest('.utility-bar__item--has-children'));
});

window.addEventListener('resize', positionOpenDropdowns, { passive: true });
document.fonts?.ready.then(positionOpenDropdowns);
